import { useState, useRef, useEffect } from "react";

const STICKER_PACKS = [
  {
    id: 'wave',
    name: 'AeThex Wave',
    icon: '🌊',
    stickers: [
      { id: 'wave-hi',    emoji: '👋', label: 'Hi there!' },
      { id: 'wave-bye',   emoji: '✌️', label: 'Peace out' },
      { id: 'wave-cool',  emoji: '😎', label: 'So cool' },
      { id: 'wave-fire',  emoji: '🔥', label: 'On fire' },
      { id: 'wave-love',  emoji: '💙', label: 'AeThex love' },
      { id: 'wave-rocket',emoji: '🚀', label: 'To the moon' },
    ],
  },
  {
    id: 'vibes',
    name: 'Good Vibes',
    icon: '✨',
    stickers: [
      { id: 'vibe-tada',   emoji: '🎉', label: 'Party time' },
      { id: 'vibe-muscle', emoji: '💪', label: 'You got this' },
      { id: 'vibe-brain',  emoji: '🧠', label: 'Big brain' },
      { id: 'vibe-trophy', emoji: '🏆', label: 'Winner' },
      { id: 'vibe-stars',  emoji: '⭐', label: 'Star power' },
      { id: 'vibe-music',  emoji: '🎵', label: 'Vibing' },
    ],
  },
  {
    id: 'mood',
    name: 'Moods',
    icon: '😶',
    stickers: [
      { id: 'mood-think',  emoji: '🤔', label: 'Hmm…' },
      { id: 'mood-facepalm', emoji: '🤦', label: 'Facepalm' },
      { id: 'mood-shrug',  emoji: '🤷', label: 'Dunno' },
      { id: 'mood-sleep',  emoji: '😴', label: 'Zzz' },
      { id: 'mood-angry',  emoji: '😤', label: 'Hmph' },
      { id: 'mood-rofl',   emoji: '🤣', label: 'LMAO' },
    ],
  },
];

export function StickerPicker({ onSelect, onClose }) {
  const [activePack, setActivePack] = useState(STICKER_PACKS[0].id);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  const pack = STICKER_PACKS.find(p => p.id === activePack);

  return (
    <div ref={ref} style={{
      position: 'absolute', bottom: '100%', left: 0, marginBottom: 8,
      width: 300, height: 340,
      background: 'var(--bg-secondary, #1e1f2e)', border: '1px solid rgba(255,255,255,0.1)',
      borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
      display: 'flex', flexDirection: 'column', zIndex: 200, overflow: 'hidden',
    }}>
      {/* Pack tabs */}
      <div style={{ display: 'flex', borderBottom: '1px solid rgba(255,255,255,0.06)', flexShrink: 0 }}>
        {STICKER_PACKS.map(p => (
          <button
            key={p.id}
            onClick={() => setActivePack(p.id)}
            title={p.name}
            style={{
              flex: 1, padding: '10px 0', background: 'none', border: 'none',
              borderBottom: activePack === p.id ? '2px solid var(--color-primary, #6366f1)' : '2px solid transparent',
              color: activePack === p.id ? 'var(--color-primary, #6366f1)' : 'rgba(255,255,255,0.4)',
              fontSize: 20, cursor: 'pointer', transition: 'all 0.15s',
            }}
          >
            {p.icon}
          </button>
        ))}
      </div>

      {/* Pack name */}
      <div style={{ padding: '6px 12px', fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '0.06em', flexShrink: 0 }}>
        {pack?.name}
      </div>

      {/* Sticker grid */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '4px 12px 12px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
          {pack?.stickers.map(s => (
            <button
              key={s.id}
              onClick={() => { onSelect(s); onClose(); }}
              title={s.label}
              style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
                padding: '12px 6px', background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.07)', borderRadius: 10,
                cursor: 'pointer', transition: 'all 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(99,102,241,0.15)'; e.currentTarget.style.borderColor = 'rgba(99,102,241,0.4)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)'; }}
            >
              <span style={{ fontSize: 32, lineHeight: 1 }}>{s.emoji}</span>
              <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.45)', textAlign: 'center' }}>{s.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
